import React from "react";
import { defaultDropList } from "../Data/WBComponentDefaults";
import { WBRenderProps } from "vagaro-website-rendering/src/components/Definitions/WBRenderProps";
import { wBComponentTypeNames } from "vagaro-website-rendering/src/components/Definitions/WBComponentTypeNames";
import { ResizeableType, WBComponent } from "./WBComponent";
import LayoutNode, { getNodeComponentAttributeValue, setNodeComponentAttributeValue } from "vagaro-website-rendering/src/components/Definitions/LayoutNode";
import { AttributeDefinition, AttributeInputType, sharedComponentAttributes } from "../Data/WBData";
import CreateAttributeList, { componentAttributeTypes } from "vagaro-website-rendering/src/components/Definitions/AttributeTypes";
import BusinessPlaceHolder from "./BusinessDataRendering/BusinessPlaceHolder";
import { GetLocationHoverAtt, GetNodeDomAttributes } from "vagaro-website-rendering/src/components/Utilities/GetNodeDomAttributes";
import { GenericBusinessControl } from "vagaro-website-rendering/src/components/Binding/GenericBusinessControl";
import WebDesigner from "../WebDesigner";
import { NodeCSSClassDefinition } from "./NodeGlobalStyleGenerator";

export default class BusinessServices extends WBComponent {

    /*

        This ended up being an API test since services will be rendred seperately for proper cart/checkout functionality.

    */

    constructor() {
        super();
        this.typename = wBComponentTypeNames.businessServices;
        this.displayName = "Services";
        this.dropList = defaultDropList;
        this.vagaroLink = "https://www.vagaro.com/shopowner/managenewservices.aspx"
        this.resizeType = ResizeableType.All;
        this.primaryEditAttributes = ["bookText", componentAttributeTypes.multiLocation, componentAttributeTypes.layoutId,componentAttributeTypes.filters, "panelRadius", "panelPadding", "panelLayoutPadding"];
        this.colorFields = ["serviceTitleColor","detailColor","descColor","panelColor","panelBorder","color","backgroundColor"];
        this.editList = [ ...this.colorFields,"bookText",componentAttributeTypes.filters,...this.primaryEditAttributes,componentAttributeTypes.multiLocation, componentAttributeTypes.alloWMultiLocalationBooking, componentAttributeTypes.layoutId,"serviceTitleColor", "panelColor","panelBorder", "panelRadius", "panelLayoutPadding", "panelPadding", ...CreateAttributeList(true, true, true, true, false, false,false)];
        this.icon = <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 512" fill="currentColor"><path d="M272.2 64.6l-51.1 51.1c-15.3 4.2-29.5 11.9-41.5 22.5L153 161.9C142.8 171 129.5 176 115.8 176H96V304c20.4 .6 39.8 8.9 54.3 23.4l35.6 35.6 7 7 0 0L219.9 397c6.2 6.2 16.4 6.2 22.6 0c1.7-1.7 3-3.7 3.7-5.8c2.8-7.7 9.3-13.5 17.3-15.3s16.4 .6 22.2 6.5L296.5 393c11.6 11.6 30.4 11.6 41.9 0c5.4-5.4 8.3-12.3 8.6-19.4c.4-8.8 5.6-16.6 13.6-20.4s17.3-3 24.4 2.1c9.4 6.7 22.5 5.8 30.9-2.6c9.4-9.4 9.4-24.6 0-33.9L340.1 243l-35.8 33c-27.3 25.2-69.2 25.6-97 .9c-31.7-28.2-32.4-77.4-1.6-106.5l70.1-66.2C303.2 78.4 339.4 64 377.1 64c36.1 0 71 13.3 97.9 37.2L505.1 128H544h40 40c8.8 0 16 7.2 16 16V352c0 17.7-14.3 32-32 32H576c-11.8 0-22.2-6.4-27.7-16H463.4c-3.4 6.7-7.9 13.1-13.5 18.7c-17.1 17.1-40.8 23.8-63 20.1c-3.6 7.3-8.5 14.1-14.6 20.2c-27.3 27.3-70 30-100.4 8.1c-25.1 20.8-62.5 19.5-86-4.1L159 404l-7-7-35.6-35.6c-5.5-5.5-12.7-8.7-20.4-9.3C96 369.7 81.6 384 64 384H32c-17.7 0-32-14.3-32-32V144c0-8.8 7.2-16 16-16H56 96h19.8c2 0 3.9-.7 5.3-2l26.5-23.6C175.5 77.7 211.4 64 248.7 64H259c4.4 0 8.9 .2 13.2 .6zM544 320V176H496c-5.9 0-11.6-2.2-15.9-6.1l-36.9-32.8c-18.2-16.2-41.7-25.1-66.1-25.1c-25.4 0-49.8 9.7-68.3 27.1l-70.1 66.2c-10.3 9.8-10.1 26.3 .5 35.7c9.3 8.3 23.4 8.1 32.5-.3l71.9-66.4c9.7-9 24.9-8.4 33.9 1.4s8.4 24.9-1.4 33.9l-.8 .8 74.4 74.4c10 10 16.5 22.3 19.4 35.1H544zM64 336a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm528 16a16 16 0 1 0 0-32 16 16 0 1 0 0 32z" /></svg>

        this.cssDefinitions =[
            new NodeCSSClassDefinition(".service-panel",
            [
                {key:"panelColor",cssProperty:"background",default:""},
                {key:"panelRadius",cssProperty:"border-radius",default:""},
                {key:"panelPadding",cssProperty:"padding",default:""},
                {key:"panelBorder",cssProperty:"border-color",default:""}

             ]),
             new NodeCSSClassDefinition(".b-panel-container",
             [
                 {key:"panelLayoutPadding",cssProperty:"padding",default:"8px"},


              ]),
             new NodeCSSClassDefinition(".service-title",
             [
                 {key:"serviceTitleColor",cssProperty:"color",default:"",stencil:"transparent"},


              ]),

              new NodeCSSClassDefinition(".service-description",
              [
                  {key:"descColor",cssProperty:"color",default:"",stencil:"transparent"},


               ]),
               new NodeCSSClassDefinition(".service-pricing",
               [
                   {key:"detailColor",cssProperty:"color",default:"",stencil:"transparent"},


                ]),
                new NodeCSSClassDefinition(".s-other:not(.promo-container) ",
                [
                    {key:"detailColor",cssProperty:"color",default:"",stencil:"transparent"},


                 ]),

                 //USE "x" key to always apply default value when generating css
              new NodeCSSClassDefinition("hr",
              [
                  {key:"panelBorder",cssProperty:"border-color",default:"white"},
                  {key:"x",cssProperty:"opacity",default:".4"}


               ]),


        ];

    }




    getComponentSpecificAttributeDefinitions(): AttributeDefinition[] {
        let bookText =    new AttributeDefinition("bookText", "Book Text", "", AttributeInputType.InputFiled);
        bookText.placeHolder = "Replace 'Book Now'";
        return [
            sharedComponentAttributes.contentSpacing,
            sharedComponentAttributes.panelRadius,
            sharedComponentAttributes.panelSpacing,
            new AttributeDefinition(componentAttributeTypes.filters, "Filters", "", AttributeInputType.ServiceCategorySelector),
            new AttributeDefinition(componentAttributeTypes.layoutId, "Layout", componentAttributeTypes.layoutId, AttributeInputType.SelectField, [
                { label: "Default", value: "1" },
                { label: "Wide", value: "2" },
                { label: "Cards", value: "3" },
            ]),
            new AttributeDefinition("panelColor", "Panel Color", "", AttributeInputType.ColorField),
            new AttributeDefinition("panelBorder", "Panel Border", "", AttributeInputType.ColorField),
            new AttributeDefinition("serviceTitleColor", "Title", "", AttributeInputType.ColorField),
            new AttributeDefinition("detailColor", "Price", "", AttributeInputType.ColorField),
            new AttributeDefinition("descColor", "Description", "", AttributeInputType.ColorField),
            bookText

        ]
    }

    onFirstTimeCreation(newParent: LayoutNode, thisLayout: LayoutNode, manager: WebDesigner): void {
        setNodeComponentAttributeValue(thisLayout, componentAttributeTypes.multiLocation, manager.props.siteData.userContext.businessId);
    }



    RenderLayout({ component, screenSize, userContext: siteData, isEditor }: WBRenderProps) {
        const atts = GetNodeDomAttributes("v-service-list resizable-container vb-control", component, screenSize, isEditor);
        const layout = getNodeComponentAttributeValue(component, componentAttributeTypes.layoutId, "1");
        const bid = getNodeComponentAttributeValue(component, componentAttributeTypes.multiLocation, siteData.businessId);
        let filters = getNodeComponentAttributeValue(component, componentAttributeTypes.filters, "");
        const bookText = getNodeComponentAttributeValue(component, "bookText", "");
        const bookTextDelimeter = bookText ? `${bookText}<bookText>` : "";
        filters = bookTextDelimeter + filters;

        if (!isEditor) {
            return <BusinessPlaceHolder node={component} inFilter={filters} dataKey="services" layout={layout} classNames={atts.className} />
        }

        return (
            <>
                <style>
                    {super.GetComponentGlobalCSS(component, true)}
                </style>
                <div {...atts} {...GetLocationHoverAtt(component,siteData)}>
                    <GenericBusinessControl key={bid} filters={filters} dataKey={"services"} userContext={siteData} layout={layout} bLocationId={bid} node={component} rootId={component.id.substring(0, 6)} />
                </div>
            </>
        )
    }
}
